import ChevronRight from '@material-ui/icons/ChevronRight'
import React from 'react'
import { Link } from 'react-router-dom'
import { useMainPageHowItWorksCardStyles } from './main-page-how-it-works-card.styles'

export type MainPageHowItWorksCardProps = {
  /** Small uppercase line (e.g. “GIVE”). */
  label: React.ReactNode
  /** Primary pill text (e.g. “Donated goods”). */
  pill: React.ReactNode
  imageSrc: string
  imageAlt?: string
  to: string
  /** `aria-label` on the card link (i18n from parent). */
  linkAriaLabel: string
}

export const MainPageHowItWorksCard: React.FC<MainPageHowItWorksCardProps> = ({
  label,
  pill,
  imageSrc,
  imageAlt = '',
  to,
  linkAriaLabel,
}) => {
  const classes = useMainPageHowItWorksCardStyles()

  return (
    <div className={classes.card}>
      <Link className={classes.cardLink} to={to} aria-label={linkAriaLabel}>
        <div className={classes.cardTop}>
          <span className={classes.stepLabel}>{label}</span>
          <span className={classes.pill}>{pill}</span>
          <span className={classes.jumpCaret} aria-hidden>
            <ChevronRight aria-hidden />
          </span>
        </div>
        <div className={classes.imageShell}>
          <svg
            className={classes.waveSvg}
            viewBox="0 0 400 28"
            preserveAspectRatio="none"
            aria-hidden
          >
            <path
              fill="#ffffff"
              d="M0,0 H400 V10 C342,26 296,8 246,22 C188,38 146,14 104,22 C72,26 42,14 20,22 C14,23 6,26 0,24 V0 Z"
            />
          </svg>
          <img className={classes.cardImage} src={imageSrc} alt={imageAlt} />
        </div>
      </Link>
    </div>
  )
}
